import React from "react";
import { ListLoading } from "../../SharedComponents/ListLoading/ListLoading";
import "./AdminAccountsList.css";
import { AdminAccountsListItem } from "./AdminAccountsListItem/AdminAccountsListItem";

// Since naming is hard - This is both used for accounts and distributors, functionality lives in the parents.
export const AdminAccountsList = ({
  items,
  title,
  type,
  listActions = [],
  loading = false,
}) => {
  return (
    <div className="AdminAccountsList">
      <div className="AdminAccountsList__header">
        <div className="AdminAccountsList__title AdminAccountsList__name">
          {title[0]}
        </div>
        <div className="AdminAccountsList__title AdminAccountsList__status">
          {title[1]}
        </div>
        <div className="AdminAccountsList__title AdminAccountsList__info">
          {title[2]}
        </div>
        <div className="AdminAccountsList__end-padder"></div>
      </div>
      <div className="AdminAccountsList__list">
        {loading && <ListLoading />}
        {!loading &&
          items.map((item) => {
            const actions = listActions.map((action) => ({
              ...action,
              id: item.id,
            }));
            return (
              <AdminAccountsListItem
                key={item.id}
                id={item.id}
                title={item.name}
                type={type}
                status={item.status}
                accounts={item.usersCount}
                usersCount={item.usersCount ? item.usersCount : 0}
                listActions={actions}
              />
            );
          })}
      </div>
    </div>
  );
};
